import { Injectable } from '@angular/core';

@Injectable()
export class LocalDataService {
	constructor() {}

	getStates() {
		return [
			{ abbr: 'AL', name: 'Alabama', id: 1 },
			{ abbr: 'AK', name: 'Alaska', id: 2 },
			{ abbr: 'AZ', name: 'Arizona', id: 3 },
			{ abbr: 'AR', name: 'Arkansas', id: 4 },
			{ abbr: 'CA', name: 'California', id: 5 },
			{ abbr: 'CO', name: 'Colorado', id: 6 },
			{ abbr: 'CT', name: 'Connecticut', id: 7 },
			{ abbr: 'DE', name: 'Delaware', id: 8 },
			{ abbr: 'DC', name: 'District Of Columbia', id: 9 },
			{ abbr: 'FL', name: 'Florida', id: 10 },
			{ abbr: 'GA', name: 'Georgia', id: 11 },
			{ abbr: 'GU', name: 'Guam', id: 12 },
			{ abbr: 'HI', name: 'Hawaii', id: 13 },
			{ abbr: 'ID', name: 'Idaho', id: 14 },
			{ abbr: 'IL', name: 'Illinois', id: 15 },
			{ abbr: 'IN', name: 'Indiana', id: 16 },
			{ abbr: 'IA', name: 'Iowa', id: 17 },
			{ abbr: 'KS', name: 'Kansas', id: 18 },
			{ abbr: 'KY', name: 'Kentucky', id: 19 },
			{ abbr: 'LA', name: 'Louisiana', id: 20 },
			{ abbr: 'ME', name: 'Maine', id: 21 },
			{ abbr: 'MD', name: 'Maryland', id: 22 },
			{ abbr: 'MA', name: 'Massachusetts', id: 23 },
			{ abbr: 'MI', name: 'Michigan', id: 24 },
			{ abbr: 'MN', name: 'Minnesota', id: 25 },
			{ abbr: 'MS', name: 'Mississippi', id: 26 },
			{ abbr: 'MO', name: 'Missouri', id: 27 },
			{ abbr: 'MT', name: 'Montana', id: 28 },
			{ abbr: 'NE', name: 'Nebraska', id: 29 },
			{ abbr: 'NV', name: 'Nevada', id: 30 },
			{ abbr: 'NH', name: 'New Hampshire', id: 31 },
			{ abbr: 'NJ', name: 'New Jersey', id: 32 },
			{ abbr: 'NM', name: 'New Mexico', id: 33 },
			{ abbr: 'NY', name: 'New York', id: 34 },
			{ abbr: 'NC', name: 'North Carolina', id: 35 },
			{ abbr: 'ND', name: 'North Dakota', id: 36 },
			{ abbr: 'OH', name: 'Ohio', id: 37 },
			{ abbr: 'OK', name: 'Oklahoma', id: 38 },
			{ abbr: 'OR', name: 'Oregon', id: 39 },
			{ abbr: 'PA', name: 'Pennsylvania', id: 40 },
			{ abbr: 'PR', name: 'Puerto Rico', id: 41 },
			{ abbr: 'RI', name: 'Rhode Island', id: 42 },
			{ abbr: 'SC', name: 'South Carolina', id: 43 },
			{ abbr: 'SD', name: 'South Dakota', id: 44 },
			{ abbr: 'TN', name: 'Tennessee', id: 45 },
			{ abbr: 'TX', name: 'Texas', id: 46 },
			{ abbr: 'UT', name: 'Utah', id: 47 },
			{ abbr: 'VT', name: 'Vermont', id: 48 },
			{ abbr: 'VA', name: 'Virginia', id: 49 },
			{ abbr: 'WA', name: 'Washington', id: 50 },
			{ abbr: 'WV', name: 'West Virginia', id: 51 },
			{ abbr: 'WI', name: 'Wisconsin', id: 52 },
			{ abbr: 'WY', name: 'Wyoming', id: 53 }
		];
	}

	getCardTypes() {
		return [
			{ name: 'Visa', iconClass: 'cc visa icon' },
			{ name: 'Mastercard', iconClass: 'cc mastercard icon' },
			{ name: 'American Express', iconClass: 'cc amex icon' },
			{ name: 'Discover', iconClass: 'cc discover icon' }
		];
	}

	getPhoneTypes() {
		return ['Home', 'Cell', 'Work'];
	}

	getMonths() {
		return [
			{ val: 1, name: 'January' },
			{ val: 2, name: 'February' },
			{ val: 3, name: 'March' },
			{ val: 4, name: 'April' },
			{ val: 5, name: 'May' },
			{ val: 6, name: 'June' },
			{ val: 7, name: 'July' },
			{ val: 8, name: 'August' },
			{ val: 9, name: 'September' },
			{ val: 10, name: 'October' },
			{ val: 11, name: 'November' },
			{ val: 12, name: 'December' }
		];
	}

	getPricingData() {
		return [
			{ 
				stationName: 'Phoenix', 
				relatedStation: 1,
				flatRate: '3.99',
				heavyBulkyFee: '2.99'
			}
		];
	}

	getStatusLabelColor(status) {
		const labels = {
			'Awaiting Drop Off': 'gray-label',
			'Order Placed': 'green-label',
			'Order Ready for Pick Up': 'green-label',
			'Order Picked Up': 'green-label',
			'Order Receipt Verified': 'green-label',
			'Order Out for Delivery': 'green-label',
			'Order Complete': 'green-label',
			'Order Damaged': 'red-label',
			'Order Not Filled': 'red-label',
			'eDelivery Not Authorized': 'red-label',
			'Unable to Access': 'red-label'
		};
		return labels[status];
	}

	getStatusTextColor(status) {
		const labels = {
			'Awaiting Drop Off': 'gray-txt-cell',
			'Order Placed': 'green-txt-cell',
			'Order Ready for Pick Up': 'green-txt-cell',
			'Order Picked Up': 'green-txt-cell',
			'Order Receipt Verified': 'green-txt-cell',
			'Order Out for Delivery': 'green-txt-cell',
			'Order Complete': 'green-txt-cell',
			'Order Damaged': 'red-txt-cell',
			'Order Not Filled': 'red-txt-cell',
			'eDelivery Not Authorized': 'red-txt-cell',
			'Unable to Access': 'red-txt-cell'
		};
		return labels[status];
	}

	getInputMasks() {
		const d = /\d/;
		const masks = {
			cc: {
				mask: [ d, d, d, d, ' ', '-', ' ', d, d, d, d, ' ', '-', ' ', d, d, d, d, ' ', '-', ' ', d, d, d, d],
				placeholderChar: '\u2000',
				guide: false
			},
			phone: {
				mask: ['(', d, d, d, ')', ' ', '-', ' ', d, d, d, ' ', '-', ' ', d, d, d, d],
				placeholderChar: '\u2000',
				guide: false
			},
			phoneExt: {
				mask: [d, d, d, d, d],
				placeholderChar: '\u2000',
				guide: false
			},
			zip: {
				mask: [d, d, d, d, d],
				placeholderChar: '\u2000',
				guide: false
			},
			cvc: {
				mask: [d, d, d, d],
				guide: false
			},
			year: {
				mask: [d, d, d, d],
				guide: false
			}
		};
		return masks;
	}

	popupText(key) {
		switch (key) {
			case 'deliveryDate': 
				return `
					eDelivery's promise is to get you your stuff as soon as possible.
					So long as the stores you order your stuff from has it ready for pick-up
					and you provide us with accurate delivery information to a readily accessible location,
					we will have your stuff to you within a day of you placing your order! 
					If you are placing this order before 11 am, we can get your stuff to you by this evening.
					If you are placing your order after 11 am, we will get you your stuff by tomorrow morning.
					If you have any questions about our delivery policy, please reach out to us using the ‘Contact Us’
					page on our site.
				`;
			case 'deliveryDateDropoff':
				return `
					eDelivery's promise is to get you your stuff as soon as possible.
					If you are dropping off this order before 11 am, we will deliver your stuff by this evening.
					If you are dropping off this order after 11 am, we will deliver your stuff by tomorrow morning.
					If you have any questions about our delivery policy, please reach out to us using the ‘Contact Us’
					page on our site.
				`;
			case 'heavyBulkyVolume':
				return `
					Standard dimensional guidelines for store orders are 2 packages (boxes or bags), 15 lbs combined weight, and 45 cubic inches.
					This surcharge is left to driver discretion, but if selected beforehand will give our team a better chance of preparing to accommodate larger orders.
				`;
			case 'heavyBulkyVolumeDropoff':
				return `
					If any package in the order exceeds 15 lbs OR average dimensions of 16x12x6, the order will be considered heavy/bulky and a $2.99 fee will be applied to the order. 
					Above 25 lbs or dimensions of 120 Inches Combined LENGTH + GIRTH will not be accepted for delivery at this time.
				`;
			case 'cvv': 
				return `
					The CVV is a 3 or 4 digit code embossed or imprinted on the signature panel on the reverse side of Visa, MasterCard and Discover cards and on the front
					of American Express cards. 
				`;
		}
	}
}
